import React from "react";
import { Switch, Route } from "react-router";
import OrganizationUserRolesIndexPage from "pages/_common/organization/OrganizationUserRolesIndexPage";
import OrganizationUserRolesCreateEditPage from "pages/_common/organization/OrganizationUserRolesCreateEditPage";

/**
 * User Roles Sub-router
 */
const OrganizationUserRolesRouter = () => {
  return (
    <Switch>
      <Route exact path="/organizations/:organization_id/roles" component={OrganizationUserRolesIndexPage} />
      <Route path="/organizations/:organization_id/roles/create" component={OrganizationUserRolesCreateEditPage} />
      <Route
        path="/organizations/:organization_id/roles/:role_id/edit"
        component={OrganizationUserRolesCreateEditPage}
      />
    </Switch>
  );
};

export default OrganizationUserRolesRouter;
